// Phone photos are often 4–10 MB. Shrinks an image to a sensible size before upload so it
// uploads quickly on mobile data and stays under the server's 5 MB limit. PDFs pass through.
const MAX_SIDE = 1800;

export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;

export async function prepareLicenceFile(file) {
  if (file.type === 'application/pdf') {
    if (file.size > MAX_UPLOAD_BYTES) throw new Error('That PDF is larger than 5 MB');
    return file;
  }
  if (!file.type.startsWith('image/')) throw new Error('Please choose a photo (JPG or PNG) or a PDF');

  let bitmap;
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  } catch {
    throw new Error('That photo could not be read. Please use a JPG or PNG, or take a new photo.');
  }

  const scale  = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width  = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  if (bitmap.close) bitmap.close();

  const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.85));
  if (!blob) throw new Error('That photo could not be processed. Please try another.');
  if (blob.size > MAX_UPLOAD_BYTES) throw new Error('That photo is still too large — please try a smaller one');
  return new File([blob], 'licence.jpg', { type: 'image/jpeg' });
}
